import { EMPTY_FIELD } from 'constants/emptyField';
import { Resources } from 'constants/resources';

import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { Link } from 'react-router-dom';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { FunctionField } from 'shared/react-admin/Fields';
import { MerchantAccount } from 'types/embedded/merchantAccount';

import { useGetColor } from './hooks/useGetColor';

export type LastActiveFieldProps = {
  label: string;
  source?: string;
  merchantId?: string;
};

export const LastActiveField: React.FC<LastActiveFieldProps> = ({ label, merchantId }) => {
  const { createPathWithQuery } = useCreatePathWithQuery();
  const { getColor } = useGetColor();

  return (
    <FunctionField
      cellClassName="column-balanceUpdatedAtMessage"
      label={label}
      render={({
        balanceUpdatedAtColor,
        balanceUpdatedAtMessage,
        provider,
        gateways,
      }: MerchantAccount) => {
        const renderContent = () => {
          return (
            <Stack
              alignItems="start"
              direction="row"
              flexWrap="nowrap"
              gap={1}
              sx={{ cursor: balanceUpdatedAtMessage ? 'pointer' : 'auto' }}
            >
              <MonitorHeartOutlinedIcon htmlColor={getColor('icon', balanceUpdatedAtColor)} />
              <Typography
                color={getColor('text', balanceUpdatedAtColor)}
                component="span"
                sx={{ whiteSpace: 'nowrap' }}
              >
                {balanceUpdatedAtMessage || EMPTY_FIELD}
              </Typography>
            </Stack>
          );
        };

        if (!balanceUpdatedAtMessage) {
          return renderContent();
        }

        const to = createPathWithQuery(
          { resource: Resources.OrderConversion, type: 'list' },
          {
            filter: {
              merchant: merchantId,
              provider: [provider?.['@id']],
              gateway: gateways?.map((gateway) => gateway?.['@id']),
            },
          },
        );

        return (
          <Link style={{ textDecoration: 'none' }} target="_blank" to={to}>
            {renderContent()}
          </Link>
        );
      }}
    />
  );
};
